// Add Loan Component JavaScript

export function init() {
    console.log('Add Loan component initialized');

    // Initialize multi-step form
    initMultiStepForm();

    // Setup form validation
    setupFormValidation();

    // Initialize HTMX behaviors for dynamic form updates
    setupHTMXFormBehaviors();
}

let currentStep = 1;
const totalSteps = 3;

function initMultiStepForm() {
    // Bind navigation functions to window for inline onclick handlers
    window.nextStep = nextStep;
    window.prevStep = prevStep;
    window.resetForm = resetForm;

    updateProgress();

    // Set minimum date to today
    const dueDateInput = document.getElementById('due-date');
    if (dueDateInput) {
        dueDateInput.min = new Date().toISOString().split('T')[0];
    }

    // Form submission handler
    const form = document.getElementById('add-loan-form');
    if (form) {
        form.addEventListener('submit', handleFormSubmit);
    }
}

function updateProgress() {
    // Update progress indicators
    const progressSteps = document.querySelectorAll('.flex.items-center');

    progressSteps.forEach((stepEl, index) => {
        const stepNum = Math.floor((index + 1) / 2);
        if (stepNum === 0) return;

        const circle = stepEl.querySelector('.rounded-full');
        const text = stepEl.querySelector('span');

        if (circle && text) {
            if (stepNum <= currentStep) {
                circle.className = 'bg-indigo-600 text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-semibold';
                text.className = 'ml-2 text-sm font-medium text-indigo-600';
            } else {
                circle.className = 'bg-gray-300 text-gray-500 rounded-full w-8 h-8 flex items-center justify-center text-sm font-semibold';
                text.className = 'ml-2 text-sm font-medium text-gray-500';
            }
        }
    });
}

function nextStep() {
    if (currentStep < totalSteps) {
        if (validateStep(currentStep)) {
            document.getElementById(`step-${currentStep}`).classList.add('hidden');
            currentStep++;
            document.getElementById(`step-${currentStep}`).classList.remove('hidden');
            updateProgress();

            if (currentStep === 3) {
                updateSummary();
            }

            // Trigger HTMX event for step change
            if (window.htmx) {
                htmx.trigger(document.body, 'step-changed', { step: currentStep });
            }
        }
    }
}

function prevStep() {
    if (currentStep > 1) {
        document.getElementById(`step-${currentStep}`).classList.add('hidden');
        currentStep--;
        document.getElementById(`step-${currentStep}`).classList.remove('hidden');
        updateProgress();

        // Trigger HTMX event
        if (window.htmx) {
            htmx.trigger(document.body, 'step-changed', { step: currentStep });
        }
    }
}

function validateStep(step) {
    const stepElement = document.getElementById(`step-${step}`);
    const requiredFields = stepElement.querySelectorAll('[required]');

    for (let field of requiredFields) {
        if (!field.value.trim()) {
            field.focus();
            field.classList.add('border-red-500');
            setTimeout(() => field.classList.remove('border-red-500'), 3000);
            showValidationMessage(field);
            return false;
        }
    }
    return true;
}

function showValidationMessage(field) {
    const label = field.previousElementSibling;
    const fieldName = label ? label.textContent.replace('*', '').trim() : 'This field';

    const message = document.createElement('div');
    message.className = 'text-red-500 text-sm mt-1';
    message.textContent = `${fieldName} is required`;

    // Remove any existing validation message
    const existing = field.parentElement.querySelector('.text-red-500');
    if (existing) existing.remove();

    field.parentElement.appendChild(message);
    setTimeout(() => message.remove(), 3000);
}

function updateSummary() {
    const formData = new FormData(document.getElementById('add-loan-form'));
    const summary = document.getElementById('loan-summary');

    if (summary) {
        summary.innerHTML = `
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <p class="text-sm text-gray-600">Loan Name</p>
                    <p class="font-semibold">${formData.get('loanName') || 'N/A'}</p>
                </div>
                <div>
                    <p class="text-sm text-gray-600">Loan Type</p>
                    <p class="font-semibold capitalize">${formData.get('loanType') || 'N/A'}</p>
                </div>
                <div>
                    <p class="text-sm text-gray-600">Current Balance</p>
                    <p class="font-semibold">$${parseFloat(formData.get('currentBalance') || 0).toLocaleString()}</p>
                </div>
                <div>
                    <p class="text-sm text-gray-600">Monthly Payment</p>
                    <p class="font-semibold">$${parseFloat(formData.get('paymentAmount') || 0).toLocaleString()}</p>
                </div>
                <div>
                    <p class="text-sm text-gray-600">Next Due Date</p>
                    <p class="font-semibold">${formatDate(formData.get('dueDate'))}</p>
                </div>
                <div>
                    <p class="text-sm text-gray-600">Interest Rate</p>
                    <p class="font-semibold">${formData.get('interestRate') || 'N/A'}%</p>
                </div>
            </div>
        `;
    }
}

function formatDate(dateString) {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
}

function resetForm() {
    const form = document.getElementById('add-loan-form');
    if (form) {
        form.reset();
        document.getElementById('success-message').classList.add('hidden');
        form.classList.remove('hidden');
        currentStep = 1;

        // Reset steps visibility
        for (let i = 1; i <= totalSteps; i++) {
            document.getElementById(`step-${i}`).classList.add('hidden');
        }
        document.getElementById('step-1').classList.remove('hidden');
        updateProgress();
    }
}

function handleFormSubmit(e) {
    e.preventDefault();

    const formData = new FormData(e.target);
    const loanData = Object.fromEntries(formData);

    // Store in localStorage for demo
    const loans = JSON.parse(localStorage.getItem('loans') || '[]');
    loans.push({
        ...loanData,
        id: Date.now(),
        createdAt: new Date().toISOString()
    });
    localStorage.setItem('loans', JSON.stringify(loans));

    // Show success message
    e.target.classList.add('hidden');
    const successMessage = document.getElementById('success-message');
    if (successMessage) {
        successMessage.classList.remove('hidden');
    }

    // Log for debugging
    console.log('Loan submitted:', loanData);

    // With HTMX, you could submit to server:
    // htmx.ajax('POST', '/api/loans', { values: loanData });
}

function setupFormValidation() {
    // Add real-time validation
    const inputs = document.querySelectorAll('input[type="number"]');
    inputs.forEach(input => {
        input.addEventListener('blur', () => {
            if (input.min && parseFloat(input.value) < parseFloat(input.min)) {
                input.value = input.min;
            }
        });
    });
}

function setupHTMXFormBehaviors() {
    if (!window.htmx) return;

    // Example: Dynamic interest rate calculation
    const principalInput = document.getElementById('principal-amount');
    const interestInput = document.getElementById('interest-rate');

    if (principalInput && interestInput) {
        // Could add HTMX attributes for server-side calculations
        console.log('HTMX available for dynamic form calculations');
    }

    // Listen for HTMX events
    document.body.addEventListener('htmx:beforeRequest', () => {
        console.log('Saving loan data...');
    });

    document.body.addEventListener('htmx:afterRequest', (event) => {
        if (event.detail.successful) {
            console.log('Loan saved successfully');
        }
    });
}

// Export functions for testing
export {
    nextStep,
    prevStep,
    validateStep,
    updateSummary,
    resetForm,
    handleFormSubmit
};